import React from 'react';
import PropTypes from 'prop-types';
//import classNames from 'classnames';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
//import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import styled from 'src/ui/library/styled';

const styles = (theme, props) => ({
  root: {},
  label: {
    color: theme.colors.eyConfidentGrey,
  },
  labelFocused: {
    color: `${theme.colors.eyConfidentGrey} !important`,
  },
  formControl: {
    display: 'flex',
  },
  formControlLabel: {
    position: 'relative',
    left: '-5px',
  },
  radioButton: {
    color: theme.colors.eyConfidentGrey,
  },
  radioButtonChecked: {
    color: `${theme.colors.eyConfidentGrey} !important`,
  },
  group: {
    flexDirection: 'row',
  },
});

class RadioBase extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override RadioBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Radio> */
    className: PropTypes.string,
    /** Value of `input` element */
    value: PropTypes.string,
    /** Text used for input label */
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
    /** If `true`, the label is displayed as required. */
    required: PropTypes.any,
    /** Callback fired when value is changed */
    onChange: PropTypes.func,
  };

  static defaultProps = {
    styles: {},
    required: false,
  };

  state = {
    value: this.props.value || undefined,
  };

  handleChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    this.setState({
      value: event.target.value,
    });
  };

  render() {
    const { classes, id, label, required, options } = this.props;

    return (
      <FormControl component="fieldset" className={classes.formControl}>
        {label && (
          <FormLabel component="legend" classes={{ root: classes.label, focused: classes.labelFocused }} required={required}>
            {label}
          </FormLabel>
        )}
        <RadioGroup
          aria-label={label ? label : 'radio group'}
          id={id}
          name={id}
          className={classes.group}
          value={this.state.value}
          onChange={this.handleChange}>
          {options.map((option, index) => {
            return (
              <FormControlLabel
                key={index}
                value={option.value}
                classes={{ label: classes.formControlLabel }}
                control={
                  <Radio
                    checked={option.value === this.state.value}
                    classes={{
                      root: classes.radioButton,
                      checked: classes.radioButtonChecked,
                    }}
                  />
                }
                label={option.label}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    );
  }
}

export { RadioBase };
export default styled(RadioBase)(styles);
